import styled from 'styled-components';
import { Text, spacing } from '@comicrelief/component-library';
import { changeTextColor } from '../RichText/utils';

const InnerCopy = styled.span`
  ${({ centredText }) => (centredText ? 'text-align: center;' : 'text-align: left;')}
  ul,
  ol {
    color: ${({ bgColor }) => changeTextColor(bgColor)};
    font-family: 'Montserrat',Helvetica,Arial,sans-serif;

    li {
      word-break: break-word;
      :not(:last-child) {
        padding-bottom: ${spacing('md')};
      }
    }
  }
  hr {
    color: ${({ bgColor }) => changeTextColor(bgColor)};
    border: 1px solid ${({ bgColor }) => changeTextColor(bgColor)};
    margin: ${spacing('md')} 0;
  }
  img {
    margin-bottom: ${spacing('l')};
  }
`;

const Label = styled(Text)`
  display: block;
  margin-bottom: ${spacing('sm')};
`;

export { InnerCopy, Label };
